import { Fragment, useEffect, useState } from "react";
import Contact from "./static/contact";
import Footer from "./static/footer";
import {
  checkPendingSubscriptionStatus,
  disposePage,
  getPendingSubscriptionById,
  setPendingSubscriptionId,
  setProcessing,
} from "../redux/slices/onboardingpageslice";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../redux/slices/currentpageslice";
import { apiErrorsHandler, getErrorMessages } from "../api/httpclient";
import { addNotification } from "../redux/slices/notificationsslice";
import { notificationDurationMiddle } from "../lib/utils";
import { useEffectOnce } from "../hooks/useeffectonce";
import nemo from "../images/nemo.png";
import cerebro from "../images/cerebro.png";
import { SvgIcon } from "@progress/kendo-react-common";
import { documentManagerIcon } from "@progress/kendo-svg-icons";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const SubscriptionPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.currentUser);
  const onBoarding = useSelector((state) => state.onBoardingPage);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [secondsLeft, setSecondsLeft] = useState(60);
  const { t } = useTranslation();
  const messages = [
    t("subscription.message1"),
    t("subscription.message2"),
    t("subscription.message3"),
    t("subscription.message4"),
    t("subscription.message5"),
    t("subscription.message6"),
    t("subscription.message7"),
    t("subscription.message8"),
    t("subscription.message9"),
  ];
  const [messageIndex, setMessageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  /*initial page load*/
  useEffectOnce(() => {
    console.log("check sub id", id);
    if (id) {
      dispatch(setPendingSubscriptionId(id));
      dispatch(getPendingSubscriptionById(id, t)).then(
        (response) => {
          console.log("pendingUser response", response);
          dispatch(checkPendingSubscriptionStatus(response, t)).then(
            (response) => {
              console.log("checkPendingSubscriptionStatus succeeded");
            },
            (err) => {
              dispatch(setProcessing({ processing: false }));

              const handleResponseReceived = (
                state,
                dispatch,
                navigate,
                payload
              ) => {
                let errorMessages = payload?.data?.ErrorMessages;

                if (!errorMessages || errorMessages.length == 0)
                  errorMessages = [t("subscription.unknown_error")];
                else errorMessages = getErrorMessages(errorMessages, 1);

                dispatch(
                  addNotification({
                    text: errorMessages[0],
                    type: "error",
                    closable: true,
                    duration: notificationDurationMiddle,
                    position: "topRight",
                  })
                );
              };

              const handleUnhandled = (state, dispatch, navigate, payload) => {
                let errorMessage = t("subscription.unknown_error");
                dispatch(
                  addNotification({
                    text: errorMessage,
                    type: "error",
                    closable: true,
                    duration: notificationDurationMiddle,
                    position: "topRight",
                  })
                );
              };

              apiErrorsHandler({}, dispatch, navigate, err, null, {
                responseReceived: handleResponseReceived,
                unhandled: handleUnhandled,
              });
            }
          );
        },
        (err) => {
          dispatch(setProcessing({ processing: false }));

          const handleResponseReceived = (
            state,
            dispatch,
            navigate,
            payload
          ) => {
            let errorMessages = payload?.data?.ErrorMessages;

            if (!errorMessages || errorMessages.length == 0)
              errorMessages = [t("subscription.unknown_error")];
            else errorMessages = getErrorMessages(errorMessages, 1);

            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              })
            );
          };

          const handleUnhandled = (state, dispatch, navigate, payload) => {
            let errorMessage = t("subscription.unknown_error");
            dispatch(
              addNotification({
                text: errorMessage,
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              })
            );
          };

          apiErrorsHandler({}, dispatch, navigate, err, null, {
            responseReceived: handleResponseReceived,
            unhandled: handleUnhandled,
          });
        }
      );
    }
    return () => {
      dispatch(setCurrentPage({ id: "", isDirty: false }));
      dispatch(disposePage(true));
    };
  }, [id]);
  /*initial load*/

  useEffect(() => {
    if (onBoarding.navigateToHome) {
      navigate("/");
    }
  }, [onBoarding.navigateToHome, navigate]);

  useEffect(() => {
    const timer = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // cleanup on unmount
  }, []);

  // Cycle messages every 3 seconds
  useEffect(() => {
    const messageCycle = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 3000);

    return () => clearInterval(messageCycle);
  }, [messages.length]);

  return (
    <Fragment>
      <div className="home-page" style={{ width: "100%", height: "100%" }}>
        <div className="faq-area ">
          <div className="container">
            {!currentUser.IsAuthenticated && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "30px",
                  color: "#555", // or any theme color
                  fontFamily: "Arial, sans-serif",
                }}
              >
                <div className={`fade-text ${fade ? "visible" : "hidden"}`}>
                  {messages[messageIndex]}
                </div>
                <div style={{ fontSize: "14px" }}>
                  {t("subscription.wait")}{" "}
                  <strong
                    style={{
                      border: "1px dashed black",
                      borderRadius: "50%",
                      padding: "8px",
                    }}
                  >
                    {secondsLeft}
                  </strong>{" "}
                  {t("subscription.seconds")}
                </div>
              </div>
            )}
            <br />
            {!currentUser.IsAuthenticated && (
              <div
                className="content"
                style={{ display: "flex", justifyContent: "space-around" }}
              >
                <div
                  style={{
                    width: "45%",
                    textAlign: "center",
                    marginRight: "20px",
                    border: "1px solid #ddd",
                    padding: "16px",
                    alignContent: "center",
                    height: "400px",
                  }}
                >
                  <img src={cerebro} alt="Intech" className="nemo" />
                  <div className="txt">
                    {t("subscription.cerebro")}
                    <br /> {t("subscription.checkout")}
                  </div>
                  <NavLink to="https://cerebro360.ai/ic360doc" target="_blank">
                    <SvgIcon
                      icon={documentManagerIcon}
                      style={{ margin: "-5px 10px 0 0" }}
                    />
                    {t("subscription.checknow")}
                  </NavLink>
                </div>

                <div
                  style={{
                    width: "45%",
                    textAlign: "center",
                    border: "1px solid #ddd",
                    padding: "16px",
                    alignContent: "center",
                    height: "400px",
                  }}
                >
                  <img src={nemo} alt="Nemo AI" className="nemo" />
                  <div className="txt">
                    {t("subscription.nemoai")}
                    <br /> {t("subscription.integration")}
                  </div>
                  <NavLink to="https://intech-mena.com/nemo-ai" target="_blank">
                    {t("subscription.know")}
                  </NavLink>
                </div>
              </div>
            )}
          </div>
        </div>
        <Contact />
        <Footer />
      </div>
      <style>
        {` 
            .fade-text {
              opacity: 0;
              transition: opacity 0.3s ease-in-out;
              font-size: 18px;
              font-weight: 600;
              margin-bottom:20px;
            }

            .fade-text.visible {
              opacity: 1;
            }

            .fade-text.hidden {
              opacity: 0;
            }
            #content {
              display: none;
              text-align: center;
            }
        `}
      </style>
    </Fragment>
  );
};
